import update from 'immutability-helper';
import shortid from 'shortid';
import _findIndex from 'lodash/findIndex';
import {
    ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP,
    ADD_LOCATION_IN_META_POPUP,
    DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    REMOVE_LOCATION_IN_META_POPUP,
    SET_LOCATIONS_IN_META_POPUP,
    UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP,
    UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP,
    UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP,
    UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP,
    UPDATE_SECTION_TITLE_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP,
    UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP,
    UPDATE_SECTION_TEAM_IN_THE_META_POPUP,
    UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP,
    UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP,
    UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP,
    UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP,
    UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP,
    UPDATE_IS_TRAVEL_PRODUCT_FIELD_IN_THE_META_EDIT_POPUP,
    OPEN_EDIT_META_SECTION_POPUP_POPUP,
    FETCHED_OVERVIEW_DATES,
    FETCHED_OVERVIEW_ACCOMMODATIONS,
    FETCHED_OVERVIEW_REQUIREMENTS,
    UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP,
    UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP,
    UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP,
    FETCHED_PRODUCTS,
    UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP,
    UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP,
    DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP,
    ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP,
    UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP,
    UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP,
    FETCHED_SNIPPET_ATTRIBUTE_OPTIONS,
} from './types';

const INITIAL_STATE = {
    allProducts: [],
    allSnippetAttributeOptions: [],
    overviewAll: {
        allDates: [],
        allAccommodations: [],
        allRequirements: [],
    },
    data: {
        title: '',
        meta_title: '',
        meta_description: '',
        snippet: '',
        locations: [],
        sectionLocations: [],
        heroImage: null,
        blog: {
            author: '',
            date: '',
        },
        review: {
            id: '',
            quote: '',
            author_full_name: '',
            author_abbreviated_name: '',
            language_id: null,
            age_group_id: null,
            products: [],
            image: null,
        },
        custom: {
            products: [],
        },
        product: {
            dates_label_id: 0,
            requirements_label_id: 0,
            accommodation_label_id: 0,
            additional_requirements: '',
            snippet_sort_order: 0,
            is_travel_product: false,
        },
        team: '',
    },
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case OPEN_EDIT_META_SECTION_POPUP_POPUP:
            return update(state, {data: {$set: action.payload.data}});

        case ADD_REVIEW_IMAGE_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    review: {
                        image: {
                            $set: {
                                id: shortid.generate(),
                                url: action.payload.image.preview,
                                preview: action.payload.image.preview,
                                alt: '',
                                title: '',
                                description: '',
                                link: '',
                                filename: action.payload.image.name,
                                name: action.payload.image.name,
                                new: true,
                                deleted: false,
                                imageObject: action.payload.image,
                                croppedImage: null,
                                croppedImageObject: null,
                                croppedImageThumb: null,
                                croppedImageThumbObject: null,
                            },
                        },
                    },
                },
            });

        case ADD_HERO_IMAGE_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    heroImage: {
                        $set: {
                            id: shortid.generate(),
                            url: action.payload.image.preview,
                            preview: action.payload.image.preview,
                            alt: '',
                            title: '',
                            description: '',
                            link: '',
                            filename: action.payload.image.name,
                            name: action.payload.image.name,
                            new: true,
                            deleted: false,
                            imageObject: action.payload.image,
                            croppedImage: null,
                            croppedImageObject: null,
                            croppedImageThumb: null,
                            croppedImageThumbObject: null,
                        },
                    },
                },
            });

        case DELETE_REVIEW_IMAGE_FIELD_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    review: {image: {$merge: {deleted: true}}},
                },
            });

        case DELETE_HERO_IMAGE_FIELD_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    heroImage: {$merge: {deleted: true}},
                },
            });

        case ADD_LOCATION_IN_META_POPUP:
            // add a new location to sectionLocation

            let sectionLocations = state.data.sectionLocations;
            let sectionLocationIndex = _findIndex(sectionLocations, {
                location_id: action.payload.location.id,
            });

            // already exists, update deleted = false
            if (sectionLocationIndex >= 0) {
                sectionLocations[sectionLocationIndex].deleted = false;
            }

            // new location
            if (sectionLocationIndex < 0) {
                sectionLocations.push({
                    id: null,
                    location_id: action.payload.location.id,
                    city: action.payload.location.city,
                    description: action.payload.location.city + ' Description',
                    deleted: false,
                });
            }

            return update(state, {
                data: {
                    sectionLocations: {$set: sectionLocations},
                },
            });

        case REMOVE_LOCATION_IN_META_POPUP:
            // remove a location from sectionLocation

            sectionLocations = state.data.sectionLocations;
            sectionLocationIndex = _findIndex(sectionLocations, {
                location_id: action.payload.location.id,
            });

            if (sectionLocationIndex >= 0) {
                sectionLocations[sectionLocationIndex].deleted = true;
            }

            return update(state, {
                data: {
                    sectionLocations: {$set: sectionLocations},
                },
            });

        case SET_LOCATIONS_IN_META_POPUP:
            let newLocations = [];

            for (let i = 0; i < action.payload.locations.length; i++) {
                newLocations.push({
                    id: action.payload.locations[i].id,
                    city: action.payload.locations[i].city,
                    active: true,
                });
            }

            return update(state, {data: {locations: {$set: newLocations}}});

        case UPDATE_SECTION_TITLE_IN_THE_META_POPUP:
            return update(state, {data: {title: {$set: action.payload}}});

        case UPDATE_HERO_CROPPED_IMAGE_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    heroImage: {
                        $merge: {
                            croppedImage: action.payload.imageUrlBlob,
                            croppedImageObject: action.payload.imageBlobObject,
                        },
                    },
                },
            });

        case UPDATE_REVIEW_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    review: {
                        image: {
                            $merge: {
                                croppedImageThumb: action.payload.imageUrlBlob,
                                croppedImageThumbObject:
                                    action.payload.imageBlobObject,
                            },
                        },
                    },
                },
            });

        case UPDATE_REVIEW_CROPPED_IMAGE_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    review: {
                        image: {
                            $merge: {
                                croppedImage: action.payload.imageUrlBlob,
                                croppedImageObject:
                                    action.payload.imageBlobObject,
                            },
                        },
                    },
                },
            });

        case UPDATE_REVIEW_IMAGE_META_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    review: {
                        image: {
                            $merge: {
                                alt: action.payload.imageMeta.alt,
                                title: action.payload.imageMeta.title,
                                description:
                                    action.payload.imageMeta.description,
                                link: action.payload.imageMeta.link,
                                name: action.payload.imageMeta.name,
                            },
                        },
                    },
                },
            });

        case UPDATE_HERO_THUMB_CROPPED_IMAGE_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    heroImage: {
                        $merge: {
                            croppedImageThumb: action.payload.imageUrlBlob,
                            croppedImageThumbObject:
                                action.payload.imageBlobObject,
                        },
                    },
                },
            });

        case UPDATE_HERO_IMAGE_META_IN_THE_EDIT_POPUP:
            return update(state, {
                data: {
                    heroImage: {
                        $merge: {
                            alt: action.payload.imageMeta.alt,
                            title: action.payload.imageMeta.title,
                            description: action.payload.imageMeta.description,
                            link: action.payload.imageMeta.link,
                            name: action.payload.imageMeta.name,
                        },
                    },
                },
            });

        case UPDATE_SNIPPET_TEXT_IN_THE_META_EDIT_POPUP:
            return update(state, {data: {snippet: {$set: action.payload}}});

        case UPDATE_SNIPPET_SORT_ORDER_FIELD_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        snippet_sort_order: {$set: action.payload},
                    },
                },
            });

        case UPDATE_SNIPPET_ATTRIBUTE_FIELD_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        snippet_attribute: {$set: action.payload},
                    },
                },
            });
        
        case UPDATE_IS_TRAVEL_PRODUCT_FIELD_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        is_travel_product: {$set: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_META_TITLE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    meta_title: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_META_DESCRIPTION_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    meta_description: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_SUBHEADING_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    subheading: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_OLD_URL_IN_THE_META_POPUP:
            return update(state, {data: {old_url: {$set: action.payload}}});

        case UPDATE_HERO_VIDEO_URL_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    hero_video_url: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_BREADCRUMB_TITLE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    breadcrumb_title: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_MENU_TITLE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    menu_title: {$set: action.payload},
                },
            });

        case UPDATE_SECTION_REVIEW_FULL_NAME_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        $merge: {author_full_name: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_REVIEW_ABBREVIATED_NAME_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        $merge: {author_abbreviated_name: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_REVIEW_QUOTE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        $merge: {quote: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_REVIEW_LANGUAGE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        $merge: {language_id: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_REVIEW_AGE_GROUP_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        $merge: {age_group_id: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_TEAM_IN_THE_META_POPUP:
            //pageBuilderMetaPopup
            return update(state, {data: {$merge: {team_id: action.payload}}});

        case UPDATE_SECTION_BLOG_AUTHOR_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    blog: {
                        $merge: {author: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_BLOG_DATE_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    blog: {
                        $merge: {date: action.payload},
                    },
                },
            });

        case FETCHED_OVERVIEW_DATES:
            return update(state, {
                overviewAll: {
                    $merge: {allDates: action.payload.dates},
                },
            });

        case FETCHED_OVERVIEW_ACCOMMODATIONS:
            return update(state, {
                overviewAll: {
                    $merge: {allAccommodations: action.payload.accommodations},
                },
            });

        case FETCHED_OVERVIEW_REQUIREMENTS:
            return update(state, {
                overviewAll: {
                    $merge: {allRequirements: action.payload.requirements},
                },
            });

        case UPDATE_OVERVIEW_DATES_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        $merge: {dates_label_id: action.payload},
                    },
                },
            });

        case UPDATE_OVERVIEW_REQUIREMENTS_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        $merge: {requirements_label_id: action.payload},
                    },
                },
            });

        case UPDATE_OVERVIEW_ADDITIONAL_REQUIREMENTS_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        $merge: {additional_requirements: action.payload},
                    },
                },
            });

        case UPDATE_OVERVIEW_ACCOMMODATION_IN_THE_META_EDIT_POPUP:
            return update(state, {
                data: {
                    product: {
                        $merge: {accommodation_label_id: action.payload},
                    },
                },
            });

        case FETCHED_PRODUCTS:
            return update(state, {
                allProducts: {
                    $set: action.payload.products,
                },
            });

        case UPDATE_SECTION_REVIEW_PRODUCTS_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    review: {
                        products: {$set: action.payload},
                    },
                },
            });

        case UPDATE_SECTION_LANDING_PRODUCTS_IN_THE_META_POPUP:
            return update(state, {
                data: {
                    custom: {
                        products: {$set: action.payload},
                    },
                },
            });

        case FETCHED_SNIPPET_ATTRIBUTE_OPTIONS:
            return update(state, {
                allSnippetAttributeOptions: {
                    $set: action.payload.options,
                },
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/builder/meta/reducer.js